import { SHOW_DIALOG, CLOSE_DIALOG } from './constants';

const showDialog = () => ({
	type: SHOW_DIALOG,
});

const closeDialog = () => ({
	type: CLOSE_DIALOG,
});

export {
	showDialog,
	closeDialog,
};
